var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedalNomada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Medalla_N\\xF3mada",
    "data-name": "Medalla N\\xF3mada",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 191.376,
    height: 140.383,
    viewBox: "0 0 191.376 140.383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86264",
    "data-name": "Rect\\xE1ngulo 86264",
    width: 191.376,
    height: 140.383,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86263",
    "data-name": "Rect\\xE1ngulo 86263",
    width: 65.795,
    height: 17.115,
    transform: "translate(58.912 111.918)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19203",
    "data-name": "Grupo 19203",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107512",
    "data-name": "Trazado 107512",
    d: "M18.729,140.383V128.73H0l6.664-13.289L0,102.155H23.57V72.782A72.774,72.774,0,0,1,95.743.016V0c.1,0,.2.009.3.009s.2-.009.3-.009V.014A72.776,72.776,0,0,1,168.514,72.78v29.373h22.862l-6.664,13.286,6.664,13.289H172.643v11.653Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107513",
    "data-name": "Trazado 107513",
    d: "M95.8,4.594V4.579c-.1,0-.188.008-.282.008s-.188-.008-.281-.008v.015A67.07,67.07,0,0,0,28.724,71.657V129.39H162.315V71.657A67.069,67.069,0,0,0,95.8,4.594",
    fill: "#fed5b5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107514",
    "data-name": "Trazado 107514",
    d: "M95.8,12.493a58.487,58.487,0,0,1,58.534,58.44v50.045a.5.5,0,0,1-.5.5H37.768a.5.5,0,0,1-.5-.5V71.027A58.488,58.488,0,0,1,95.71,12.493H95.8m57.528,107.982V71.027a57.53,57.53,0,1,0-115.059-.479c0,.159,0,.319,0,.479v49.447Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107515",
    "data-name": "Trazado 107515",
    d: "M7,98.729l6.14,12.244L7,123.221H40.83V98.729Z",
    fill: "#f48431"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107516",
    "data-name": "Trazado 107516",
    d: "M149.558,98.729v24.492h33.829l-6.141-12.248,6.141-12.244Z",
    fill: "#f48431"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107517",
    "data-name": "Trazado 107517",
    d: "M81.526,103.608h38.743s2.9-7.021-4.819-5.941c0,0-8.487.463-6.79-7.1,0,0,.67-5.712,18.388-3.628,0,0-2.958-6.247-11.136-11.493,0,0-7.975,6.492-11.625,5.329,0,0-3.057-1.824-3.045-8.592l-.955-2.273H92.814a29.148,29.148,0,0,0-22.033,9.779l16.818.771s7.869,2.315,2.314,10.8l-4.079,1.417-3.087.435s-8.065,2.777-1.221,10.492",
    fill: "#7eccc9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107518",
    "data-name": "Trazado 107518",
    d: "M57.125,105.536a2.082,2.082,0,0,1-.974-2.347q2.8-20.262,20.626-30.249a2.533,2.533,0,0,1,1.3-.357,1.37,1.37,0,0,1,1.287,1.148,1.489,1.489,0,0,1-.743,1.712c-1.1.667-2.212,1.3-3.305,1.977a7.589,7.589,0,0,0-1.555,1.257h.79c3.8,0,7.611-.021,11.416.008a7.69,7.69,0,0,1,3.02,14.726,10.165,10.165,0,0,1-4.148.684,4.167,4.167,0,1,0-.146,8.332c1.722.04,3.445.011,5.168.011h27.924c1.036,0,1.369-.222,1.509-1.005a1.648,1.648,0,0,0-1.074-1.907,3.66,3.66,0,0,0-1.058-.138,38.6,38.6,0,0,1-4.77-.142,6.926,6.926,0,0,1-5.868-7.342,7.027,7.027,0,0,1,6.931-6.559c3.187-.059,6.376-.015,9.565-.017h1.034c-.6-.71-1.075-1.3-1.575-1.859a37,37,0,0,0-6.27-5.572,1.023,1.023,0,0,0-1.29-.085c-2.346,1.33-4.715,2.619-7.084,3.909-3.238,1.763-6.456-.043-6.6-3.71-.056-1.479-.8-2.745-1.174-4.118a3,3,0,0,0-3.7-2.523c-1.527.172-3.078.135-4.618.193-.154.006-.307.027-.461.031a1.573,1.573,0,0,1-1.739-1.381,1.526,1.526,0,0,1,1.506-1.7,71.7,71.7,0,0,1,7.544-.092,37.728,37.728,0,0,1,20.219,7.561,39.017,39.017,0,0,1,15.81,27.2,2.078,2.078,0,0,1-.97,2.347Zm2.3-3.151H78.7c-.154-.285-.275-.5-.391-.723a6.974,6.974,0,0,1-.761-4.479A7.321,7.321,0,0,1,85,90.925a9.443,9.443,0,0,0,2.064-.175,4.523,4.523,0,0,0,3.347-4.973,4.58,4.58,0,0,0-4.591-3.971q-7.677-.027-15.352.013a1.554,1.554,0,0,0-.978.444A35.578,35.578,0,0,0,61.209,95.3a33.749,33.749,0,0,0-1.782,7.083m71.866,0a1.714,1.714,0,0,0,.024-.3,35.464,35.464,0,0,0-4.889-13.273.841.841,0,0,0-.605-.34c-4.112-.018-8.225-.057-12.336.01a3.854,3.854,0,0,0-3.846,3.913,3.932,3.932,0,0,0,4.069,3.856c1.337.009,2.673-.013,4.01.007a4.725,4.725,0,0,1,4.514,3.442,16.068,16.068,0,0,1,.255,2.685ZM112.431,75.628a34.458,34.458,0,0,0-9.6-3.442,1.159,1.159,0,0,0,0,.275,14.7,14.7,0,0,1,1.566,5.9,1.01,1.01,0,0,0,1.5.813c2.148-1.13,4.269-2.31,6.534-3.544"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107519",
    "data-name": "Trazado 107519",
    d: "M55.11,61.253c1.056,1.314,2.131,1.323,3.276.025a1.5,1.5,0,0,0,.087-1.968,1.446,1.446,0,0,0-1.982-.368,11.583,11.583,0,0,0-1.381,1.385Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107520",
    "data-name": "Trazado 107520",
    d: "M64.6,53.665a5.37,5.37,0,0,0-2.715,1.709,1.335,1.335,0,0,0,.139,1.716,1.3,1.3,0,0,0,1.582.475,12.757,12.757,0,0,0,2.24-1.323,1.319,1.319,0,0,0,.324-1.626,1.532,1.532,0,0,0-1.57-.951"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107521",
    "data-name": "Trazado 107521",
    d: "M69.732,52.026a1.461,1.461,0,0,0,1.509,1.5c.963-.07,2.306-.632,2.25-1.843a1.557,1.557,0,0,0-1.518-1.518,2.142,2.142,0,0,0-2.241,1.864"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107522",
    "data-name": "Trazado 107522",
    d: "M134.891,61.253c-1.056,1.314-2.131,1.323-3.276.025a1.5,1.5,0,0,1-.087-1.968,1.446,1.446,0,0,1,1.982-.368,11.582,11.582,0,0,1,1.381,1.385Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107523",
    "data-name": "Trazado 107523",
    d: "M125.4,53.665a5.37,5.37,0,0,1,2.715,1.709,1.335,1.335,0,0,1-.139,1.716,1.3,1.3,0,0,1-1.582.475,12.757,12.757,0,0,1-2.24-1.323,1.319,1.319,0,0,1-.324-1.626,1.532,1.532,0,0,1,1.57-.951"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107524",
    "data-name": "Trazado 107524",
    d: "M120.269,52.026a1.461,1.461,0,0,1-1.509,1.5c-.963-.07-2.306-.632-2.25-1.843a1.557,1.557,0,0,1,1.518-1.518,2.142,2.142,0,0,1,2.241,1.864"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107525",
    "data-name": "Trazado 107525",
    d: "M85.834,71.454a1.543,1.543,0,0,1-3.086.024,1.543,1.543,0,1,1,3.086-.024"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107526",
    "data-name": "Trazado 107526",
    d: "M59.428,102.385A33.7,33.7,0,0,1,61.209,95.3a35.576,35.576,0,0,1,8.282-13.039,1.551,1.551,0,0,1,.977-.443q7.677-.042,15.351-.013a4.579,4.579,0,0,1,4.591,3.97,4.525,4.525,0,0,1-3.347,4.974A9.372,9.372,0,0,1,85,90.925a7.323,7.323,0,0,0-7.456,6.259,6.976,6.976,0,0,0,.762,4.479c.116.22.237.438.391.722Z",
    fill: "#cad79f"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107527",
    "data-name": "Trazado 107527",
    d: "M131.293,102.39h-8.8a16.175,16.175,0,0,0-.256-2.686,4.723,4.723,0,0,0-4.514-3.441c-1.336-.021-2.673,0-4.009-.008a3.932,3.932,0,0,1-4.07-3.855,3.856,3.856,0,0,1,3.846-3.914c4.112-.067,8.225-.027,12.337-.009a.833.833,0,0,1,.6.34,35.447,35.447,0,0,1,4.889,13.273,1.625,1.625,0,0,1-.024.3",
    fill: "#cad79f"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107528",
    "data-name": "Trazado 107528",
    d: "M112.431,75.628c-2.265,1.234-4.386,2.414-6.534,3.544a1.01,1.01,0,0,1-1.5-.813,14.7,14.7,0,0,0-1.566-5.9,1.159,1.159,0,0,1,0-.275,34.458,34.458,0,0,1,9.6,3.442",
    fill: "#cad79f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107529",
    "data-name": "Trazado 107529",
    d: "M109.371,42.114A13.512,13.512,0,1,1,95.86,28.6a13.511,13.511,0,0,1,13.511,13.511",
    fill: "#f8b8d1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107530",
    "data-name": "Trazado 107530",
    d: "M105.733,42.166a9.822,9.822,0,1,1-9.822-9.822,9.822,9.822,0,0,1,9.822,9.822",
    fill: "#fce3ed"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107531",
    "data-name": "Trazado 107531",
    d: "M80.27,40.737c.012.124.023.248.036.371,0,.047.012.094.015.114A15.548,15.548,0,0,1,106.642,30.9a15.272,15.272,0,0,1,4.77,10.366c.011-.071.024-.155.038-.239v2.131c-.012-.052-.025-.1-.037-.156A15.605,15.605,0,0,1,96.8,57.665l.306.039H94.353l.561-.04a15.253,15.253,0,0,1-10.069-4.552A15.025,15.025,0,0,1,80.33,43c-.005.048-.01.082-.013.116-.016.176-.032.352-.047.527Zm2.088,1.353a13.5,13.5,0,1,0,13.5-13.47,13.47,13.47,0,0,0-13.5,13.47"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107532",
    "data-name": "Trazado 107532",
    d: "M95.876,53.039a10.794,10.794,0,0,1-3.537-.584,10.926,10.926,0,0,1-4.8-3.268,10.587,10.587,0,0,1-2.1-3.814,9.975,9.975,0,0,1-.448-2.309c-.024-.362-.051-.725-.049-1.088a10.68,10.68,0,0,1,.376-2.7c.042-.159.085-.317.139-.472a1.038,1.038,0,0,1,2,.547c-.1.425-.216.846-.295,1.275a8.382,8.382,0,0,0-.1,2.237,8.634,8.634,0,0,0,.593,2.514,8.8,8.8,0,0,0,3.1,3.933,8.157,8.157,0,0,0,3.38,1.458,8.675,8.675,0,0,0,8.621-3.141,8.1,8.1,0,0,0,1.747-3.679,8.837,8.837,0,0,0-6.973-10.5,8.725,8.725,0,0,0-4.3.236,1.02,1.02,0,0,1-1.163-.347,1.036,1.036,0,0,1,.522-1.646,9.265,9.265,0,0,1,1.687-.392,11.076,11.076,0,0,1,1.993-.1,10.657,10.657,0,0,1,2.987.531,10.794,10.794,0,0,1,3,1.54,10.994,10.994,0,0,1,2.449,2.451,10.862,10.862,0,0,1,1.86,4.228,10.342,10.342,0,0,1,.212,2.683,10.974,10.974,0,0,1-5.211,8.8,10.8,10.8,0,0,1-3.31,1.347,10.636,10.636,0,0,1-2.378.265"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107533",
    "data-name": "Trazado 107533",
    d: "M94.806,47.583c.01-.322.007-.315-.289-.426a6.04,6.04,0,0,1-.724-.314,1.027,1.027,0,0,1,.425-1.937,1.665,1.665,0,0,1,.528.106c.173.052.335.14.506.2a1.022,1.022,0,0,0,.82-1.871c-.346-.174-.713-.309-1.071-.46a3.1,3.1,0,0,1-.3-5.682.172.172,0,0,0,.117-.184,5.58,5.58,0,0,1,.025-.777,1.013,1.013,0,0,1,1.012-.882,1.024,1.024,0,0,1,1.022.9,3.345,3.345,0,0,1,.021.557c-.005.131.049.174.165.215a8.29,8.29,0,0,1,.864.348,1.015,1.015,0,0,1,.522,1.161,1.029,1.029,0,0,1-.992.786,2.115,2.115,0,0,1-.549-.133c-.227-.07-.443-.18-.673-.228a.989.989,0,0,0-1.1.644,1,1,0,0,0,.467,1.257c.361.175.737.319,1.109.471a3.155,3.155,0,0,1,1.767,1.682,3.092,3.092,0,0,1-1.363,3.961.334.334,0,0,0-.215.365,3.385,3.385,0,0,1-.022.66,1.033,1.033,0,0,1-1.028.87,1.023,1.023,0,0,1-1-.878c-.019-.137-.025-.275-.037-.413"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_107534",
    "data-name": "Trazado 107534",
    d: "M87.846,35.127a1.037,1.037,0,0,1,1.02-1.042,1.043,1.043,0,1,1-1.02,1.042"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86262",
    "data-name": "Rect\\xE1ngulo 86262",
    width: 141.858,
    height: 29.174,
    transform: "translate(24.265 104.788)",
    fill: "#fdab68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19202",
    "data-name": "Grupo 19202",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19201",
    "data-name": "Grupo 19201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19200",
    "data-name": "Grupo 19200",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "N\\xD3MADA",
    transform: "translate(58.912 123.262)",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "0.169em"
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.17em"
  }, "\xD3"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.169em"
  }, "MAD"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "A"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalNomada);
export default __webpack_public_path__ + "static/media/medal-nomada.1c6aff5cf4a2c1f352d8539f7e301489.svg";
export { ForwardRef as ReactComponent };